@if (isOpen()) {
<div class="chat-agent-window" role="dialog" aria-label="Ventana de chat del agente" aria-modal="false">
    <div class="chat-agent-header">
        <div class="chat-agent-title">
            <i class="fa-solid fa-robot" aria-hidden="true"></i>
            <span>Agente</span>
        </div>
        <button type="button" class="chat-agent-close" (click)="closeChat()" aria-label="Cerrar chat del agente">
            <i class="fa-solid fa-xmark" aria-hidden="true"></i>
        </button>
    </div>

    <div #chatBody class="chat-agent-body">
        @for (message of chatMessages(); track $index) {
        <div class="chat-message chat-message--{{ message.role }}" [innerHTML]="message.text | markdown">
        </div>
        }
    </div>

    <form class="chat-agent-footer" (ngSubmit)="sendMessage()">
        <input type="text" class="form-control" [appAutofocus]="isOpen()" [value]="chatInput()"
            (input)="chatInput.set($any($event.target).value)" placeholder="Escribe tu mensaje..."
            aria-label="Mensaje para el agente" />
        <button type="submit" class="btn btn-primary btn-sm" aria-label="Enviar mensaje al agente">
            <i class="fa-solid fa-paper-plane" aria-hidden="true"></i>
        </button>
    </form>
</div>
}

<button type="button" class="chat-agent-bubble" (click)="toggleChat()" aria-label="Abrir agente de chat"
    title="Abrir agente de chat">
    <i class="fa-solid fa-robot" aria-hidden="true"></i>
</button>